/** Shared visual language for public marketing pages (integrations / tech SaaS). */

export const PM_COLORS = {
  navy: "#0b1220",
  slate: "#0f172a",
  cyan: "#22d3ee",
  teal: "#4cceac",
  violet: "#818cf8",
  electric: "#38bdf8",
  brandGold: "#ffbf00",
  textPrimary: "#f1f5f9",
  textSecondary: "rgba(226, 232, 240, 0.88)",
  textMuted: "rgba(148, 163, 184, 0.95)",
};

export const publicFadeUpKeyframes = {
  "0%": { opacity: 0, transform: "translateY(18px)" },
  "100%": { opacity: 1, transform: "translateY(0)" },
};

/** Page background: deep navy, cyan/violet glow, subtle tech grid. */
export function publicPageRootSx(overrides = {}) {
  return {
    minHeight: "100%",
    position: "relative",
    overflow: "hidden",
    py: { xs: 3, md: 5 },
    color: PM_COLORS.textPrimary,
    background: `
      radial-gradient(ellipse 80% 50% at 15% -5%, rgba(56, 189, 248, 0.2), transparent 55%),
      radial-gradient(ellipse 55% 45% at 95% 5%, rgba(129, 140, 248, 0.16), transparent 50%),
      radial-gradient(ellipse 45% 35% at 70% 100%, rgba(76, 206, 172, 0.14), transparent 45%),
      linear-gradient(180deg, #0b1220 0%, #0f172a 50%, #0c1525 100%)
    `,
    "@keyframes fadeUp": publicFadeUpKeyframes,
    "&::before": {
      content: '""',
      position: "absolute",
      inset: 0,
      backgroundImage: `
        linear-gradient(rgba(56, 189, 248, 0.045) 1px, transparent 1px),
        linear-gradient(90deg, rgba(56, 189, 248, 0.045) 1px, transparent 1px)
      `,
      backgroundSize: "40px 40px",
      pointerEvents: "none",
      maskImage: "linear-gradient(180deg, #000 0%, transparent 90%)",
      WebkitMaskImage: "linear-gradient(180deg, #000 0%, transparent 90%)",
    },
    ...overrides,
  };
}

export const publicCardSx = {
  borderRadius: 3,
  border: "1px solid rgba(56, 189, 248, 0.2)",
  backgroundColor: "rgba(15, 23, 42, 0.65)",
  backdropFilter: "blur(8px)",
  color: PM_COLORS.textSecondary,
  boxShadow:
    "0 4px 24px rgba(0, 0, 0, 0.25), inset 0 1px 0 rgba(255, 255, 255, 0.04)",
};

export const publicCardHoverSx = {
  transition:
    "transform 0.22s ease, border-color 0.22s ease, box-shadow 0.22s ease",
  "&:hover": {
    transform: "translateY(-3px)",
    borderColor: "rgba(76, 206, 172, 0.45)",
    boxShadow:
      "0 12px 32px rgba(0, 0, 0, 0.35), 0 0 0 1px rgba(56, 189, 248, 0.12)",
  },
};

export const publicHeroChipSx = {
  mb: 1,
  fontWeight: 700,
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  fontSize: "0.7rem",
  height: "auto",
  py: 0.5,
  bgcolor: "rgba(56, 189, 248, 0.1)",
  color: PM_COLORS.cyan,
  border: "1px solid rgba(56, 189, 248, 0.35)",
};

export const publicTitleSx = {
  color: PM_COLORS.textPrimary,
  fontWeight: 800,
};

export const publicSubtitleSx = {
  color: PM_COLORS.textSecondary,
};

export const publicAccentTextSx = {
  background: `linear-gradient(90deg, ${PM_COLORS.cyan}, ${PM_COLORS.teal})`,
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
};

export const publicTopBarSx = {
  background: "rgba(11, 18, 32, 0.88)",
  backdropFilter: "blur(14px)",
  borderBottom: "1px solid rgba(56, 189, 248, 0.18)",
  boxShadow: "0 4px 24px rgba(0, 0, 0, 0.35)",
};
